import {
  ApplicationInsightsService,
  ClickEventInfo,
} from '@abb-procure/application-insights';
import { UserState } from '@abb-procure/data';
import { inject, Injectable } from '@angular/core';
import { SearchState } from '../store/search.state';
import { SearchBaseDto } from '../types/search-base-dto.type';
import { SearchResultItemDto } from '../types/search-result-item-dto.type';

@Injectable({
  providedIn: 'root',
})
export class SearchInsightsService {
  private readonly appInsightsService = inject(ApplicationInsightsService);
  private readonly state = inject(SearchState);
  private readonly currentUser = inject(UserState).current;

  logEvent(eventInfo: {
    name: string;
    rank: number;
    item: SearchResultItemDto | SearchBaseDto;
  }): void {
    this.appInsightsService.trackClickEvent(
      this.createProperties(eventInfo.name, eventInfo.rank, eventInfo.item),
    );
  }

  private createProperties(
    name: string,
    rank: number,
    item: SearchResultItemDto | SearchBaseDto,
  ): ClickEventInfo {
    return {
      elementName: name,
      entityId: item.id,
      entityNumber: item.entityNumber,
      rank: rank.toString(),
      searchId: this.state.sessionId,
      searchTerm: this.state.searchTerm(),
      tabName: this.state.activeTab()?.name ?? 'all',
      userEmail: this.currentUser()?.email,
      userId: this.currentUser()?.id.toString(),
    };
  }
}
